var exports = {
  "k": "x52a3aa3b--dc113c--container",
  "Q": "x52a3aa3b--dc113c--text",
};

module.exports = exports;
